<template src="./statistiche.html"></template>

<script>
import tabella from "@/components/statistiche/VTable";
import grafico from "@/components/statistiche/Grafico";
import ToolbarStatistiche from "@/components/statistiche/ToolbarStatistiche";
import TabellaFatturato from "@/components/statistiche/TabellaFatturato.vue";
import calendar from "@/components/ui/Calendar";

import DettaglioCliente from "@/components/dialog/statistiche/DettaglioCliente.vue";
import DettaglioAgente from "@/components/dialog/statistiche/DettaglioAgente.vue";

import Tendenze from "@/components/statistiche/Tendenze.vue";
import Promozioni from "@/components/statistiche/Promozioni.vue";

import {
  get_tabella,
  get_tabellaAgente,
  get_pdf,
} from "@/api/api.statistiche.js";

import * as XLSX from "xlsx/xlsx.mjs";

export default {
  props: {
    role: { type: String, default: "" },
  },

  components: {
    tabella,
    grafico,
    calendar,
    ToolbarStatistiche,
    DettaglioCliente,
    DettaglioAgente,
    TabellaFatturato,
    Tendenze,
    Promozioni,
  },

  data: () => ({
    select: [],
    agente: { CodAgente: 0, Nome: "" },
    dialogPDF: false,
    dati: [],
    datiC: [],

    filtroTipologia: "Fatturato",

    startYear: 2018,
    annoSel: 0,
    anni: [],

    dataDa: new Date().getFullYear().toString() + "-" + "01" + "-" + "01",
    dataA: new Date().toISOString().substr(0, 10),

    annoSel1: 0,
    annoSel2: 0,
    dataDa2: new Date().getFullYear().toString() + "-" + "01" + "-" + "01",
    dataA2: new Date().toISOString().substr(0, 10),
    dataChange: false,

    toggle_grafici: 0,
    attesa: false,
    attesaGrafico: true,
    confrontoDate: false,
    tabs: 0,

    search: "",
    datiTabellaR: [],
    datiTabellaA: [],
    headersTabella: [],
    headersTabellaAgenti: [],
    paginationS: {
      sortBy: "ClRagSoc",
      rowsPerPage: 60,
    },

    paginationA: {
      sortBy: "AnNomAge",
      rowsPerPage: 60,
    },

    helpTip: false,

    dialogCliente: false,
    dialogAgente: false,
    rigaSelezionata: null,

    dialogUser: null,
    dialogRole: "",
    caricaFatturato: false,

    filtroConfermati: true,
    filtroGrafico: [],
    aggiornaRiepilogo: false,

    //filtri della ToolbarStatistiche
    filtriSel: "",
    tuttiSel: "",
    //filtri tipologia ordini
    tipoFiltroSel: 0,
    filtriFatturato: ["Confermati", "Consegnati", "Da consegnare"],

    //campi ordinamento dialog esportazione pdf
    itemsDec: ["Decrescente", "Crescente"],
    itemsOrdinamento: [
      { text: "Nome Agente", value: "AnNomAge" },
      { text: "Ragione Sociale", value: "ClRagSoc" },
      { text: "Periodo 1", value: "QuantitaPeriodo1" },
      { text: "Periodo 2", value: "QuantitaPeriodo2" },
      { text: "Incremento", value: "PercIncremento" },
    ],
    columnSel: {},
    ordSel: "Crescente",

    //matrice dei dati per il caricamento del foglio excel
    datiExcel: [],
    datiExcelConfronto: [],

    //tendenze
    caricaDatiTendenze: false,

    //promozioni
    caricaDatiPromozioni: false,
  }),

  methods: {
    //#region HEADERS TABELLA RIEPILOGO
    returnHeadersTabella() {
      return [
        { text: "Nome", value: "AnNomAge", sortable: true, fatturato: "Nome" },
        {
          text: "Ragione Sociale",
          value: "ClRagSoc",
          sortable: true,
          fatturato: "Ragione Sociale",
        },
        { text: "Qta Periodo 1", value: "QuantitaPeriodo1", sortable: true },
        { text: "Qta Periodo 2", value: "QuantitaPeriodo2", sortable: true },
        { text: "Incremento", value: "PercIncremento", sortable: true },
      ];
    },

    returnHeadersTabellaAgenti() {
      return [
        { text: "Nome", value: "AnNomAge", fatturato: "Nome", sortable: true },
        { text: "Qta Periodo 1", value: "QuantitaPeriodo1", sortable: true },
        { text: "Qta Periodo 2", value: "QuantitaPeriodo2", sortable: true },
        { text: "Incremento", value: "PercIncremento", sortable: true },
      ];
    },
    //#endregion

    //#region FUNZIONI
    refresh() {
      if (this.tabs == null || this.tabs == 0) this.caricaDati();
      else if (
        (this.tabs == 3 && this.role == "Admin") ||
        (this.tabs == 3 && (this.role == "Agente" || this.role == "AgenteCapo"))
      ) {
        this.caricaDatiTendenze = true;
      } else if (this.tabs == 4) this.caricaDatiPromozioni = true;
      else {
        this.attesa = true;
        this.aggiornaRiepilogo = true;
      }
    },

    CambioData() {
      this.refresh();
      /* if (this.tabs == 4) this.caricaDatiPromozioni = true;
      else if (!this.dataChange) this.dataChange = true; */
    },

    returnParams(type = "") {
      //type == "PDF" aggiungo l'ordinamento delle righe del pdf
      let role = this.$store.getters["user/getRole"];
      let par = "";

      if (type == "PDF" && role.toLowerCase() == "admin" && this.tabs == 2) {
        par += "/agente";
      }
      if (this.userSwitch.Codice)
        par += "/" + this.userSwitch.Tipo + "/" + this.userSwitch.Codice;
      else if (role == "Cliente" || role == "Agente" || role == "AgenteCapo") {
        par = "/" + role + "/" + this.$store.getters["user/getCodice"];
      }

      //let date = dateToolbar;
      if (this.tipoFiltroSel == 0) par += "/1";
      // confermati
      else if (this.tipoFiltroSel == 1) par += "/3";
      // consegnati
      else par += "/0"; //da confermare

      //filtro dei marchi selezionati
      if (this.tuttiSel) par += "/Tutti";
      else {
        if (this.filtriSel.length <= 0) par += "/" + "nessuno";
        else {
          let filtri = "";
          for (let i = 0; i < this.filtriSel.length; i++) {
            filtri += this.filtriSel[i] + ";";
          }
          par += "/" + filtri;
        }
      }

      if (
        this.tabs == 2 &&
        this.role == "Admin" &&
        this.userSwitch.Tipo == "Agente"
      )
        par = par.replace("/Agente", "");

      //aggiungo l'ordinamento per la stampa sull'esportazione PDF del riepilogo
      if (type == "PDF") {
        if (this.tabs == 1 || this.tabs == 2) {
          par += this.filtroTipologia == "Fatturato" ? "/F" : "/Q";

          if (this.columnSel == null || this.columnSel.value == undefined)
            par += "/default";
          else par += "/" + this.columnSel.value;

          if (this.ordSel == "Crescente") par += "/asc";
          else if (this.ordSel == "Decrescente") par += "/desc";
          else par += "/default";
        }
      }
      return par;
    },

    verificaPeriodi() {
      if (this.dataDa >= this.dataA) return false;
      if (this.dataDa2 >= this.dataA2) return false;
      if (this.dataA == this.dataA2 && this.dataDa == this.dataDa2)
        return false;
      return true;
    },
    //#endregion

    //#region CARICAMENTO DATI
    async caricaDati() {
      if (!this.verificaPeriodi()) return;
      if (this.tabs != null && this.tabs != 0) return;

      this.attesa = true;
      this.attesaGrafico = true;
      //valore per il refresh dei dati nella tabellaFatturato
      this.caricaFatturato = !this.caricaFatturato;
      this.dataChange = false;
    },

    //funzione richiamata da toolbarStatistiche.vue per caricare i dati dopo aver inserito i filtri
    async caricaDatiTabella(dateToolbar) {
      if (this.tabs != 1 && this.tabs != 2) return;

      this.attesa = true;
      this.aggiornaRiepilogo = false;
      this.dataChange = false;
      this.datiTabella = [];
      if (!this.confrontoDate) {
        this.dataDa = this.annoSel1 + "-" + "01" + "-" + "01";
        this.dataA = this.annoSel1 + "-" + "12" + "-" + "31";

        this.dataDa2 = this.annoSel2 + "-" + "01" + "-" + "01";
        this.dataA2 = this.annoSel2 + "-" + "12" + "-" + "31";
      }
      let res = null;
      let par = this.returnParams();

      let tabella = "";
      if (this.tabs == 2) {
        tabella = "Riepilogo A";
        res = await get_tabellaAgente(par, dateToolbar);
      } else {
        tabella = "Riepilogo";
        res = await get_tabella(par, dateToolbar);
      }
      if (res == null || res.data == null) this.datiTabella = [];
      else this.datiTabella = res.data.DatiTabella;
      //salvo la matrice dei dati del foglio excel
      this.datiExcel = res.data.DatiExcel;

      await this.popolaTabella(
        this.datiTabella,
        dateToolbar,
        res.data.SommaQtaPeriodo1,
        res.data.SommaQtaPeriodo2,
        tabella,
        res.data.SommaFPeriodo1Str,
        res.data.SommaFPeriodo2Str,
        res.data.PercIncrFatt,
        res.data.PercIncrQta
      );

      this.attesa = false;
    },

    async popolaTabella(
      dati,
      date,
      totP1,
      totP2,
      tipo,
      totF1,
      totF2,
      incrFatt,
      incrQta
    ) {
      if (tipo == "Riepilogo") {
        this.headersTabella = await this.returnHeadersTabella();
        this.datiTabellaR = dati;
        if (totP1 != undefined && totP2 != undefined && totP1 != 0) {
          this.headersTabella[2].text = "Qta Periodo 1(" + totP1 + ")";
          this.headersTabella[2].fatturato = "Periodo 1 (" + totF1 + " €)";
          this.headersTabella[3].text = "Qta Periodo 2(" + totP2 + ")";
          this.headersTabella[3].fatturato = "Periodo 2 (" + totF2 + " €)";
          this.headersTabella[4].text = "Incremento(" + incrQta + "%)";
          this.headersTabella[4].fatturato = "Incremento(" + incrFatt + "%)";
          this.changeSortValue(this.filtroTipologia);
        }
      } else if (tipo == "Riepilogo A") {
        this.headersTabellaAgenti = await this.returnHeadersTabellaAgenti();
        this.datiTabellaA = dati;
        if (totP1 != undefined && totP2 != undefined && totP1 != 0) {
          this.headersTabellaAgenti[1].text = "Qta Periodo 1(" + totP1 + ")";
          this.headersTabellaAgenti[1].fatturato =
            "Periodo 1 (" + totF1 + " €)";
          this.headersTabellaAgenti[2].text = "Qta Periodo 2(" + totP2 + ")";
          this.headersTabellaAgenti[2].fatturato =
            "Periodo 2 (" + totF2 + " €)";
          this.headersTabellaAgenti[3].text =
            "Incremento(" + (((totP2 - totP1) / totP1) * 100).toFixed(2) + "%)";
          this.headersTabellaAgenti[3].fatturato =
            "Incremento(" + (((totF2 - totF1) / totF1) * 100).toFixed(2) + "%)";
        }
      }

      if (
        date != null &&
        date.dataDa1 != "" &&
        date.dataA1 != "" &&
        date.dataDa2 != "" &&
        date.dataA2 != ""
      ) {
        this.dataDa = date.DataDa1;
        this.dataA = date.DataA1;
        this.dataDa2 = date.DataDa2;
        this.dataA2 = date.DataA2;
      }
    },

    caricaAltriDati(dati, datiC, datixls, datixlsC) {
      this.dati = dati;
      this.datiC = datiC;

      //carico anche i dati per l'esportazione del foglio excel
      this.datiExcel = datixls;
      this.datiExcelConfronto = datixlsC;

      this.attesa = false;
      this.attesaGrafico = false;
      this.filtroGrafico = [];

      if (!this.confrontoDate) this.filtroGrafico = this.getFiltroGrafico();
      if (this.datiC != undefined && this.confrontoDate)
        this.filtroGrafico = this.getFiltroGraficoConfronto();
    },

    getSomma(tipo) {
      let res = 0;
      let arrFilter = this.dati;
      arrFilter = arrFilter.filter((x) => x.Filtro == this.filtroTipologia);
      if (tipo) arrFilter = arrFilter.filter((x) => x.Tipologia == tipo);

      arrFilter.forEach((value) => {
        // Ciclo sulle chiavi del json
        for (var key in value) {
          // Escludo colonna
          if (value[key] == -1) continue;
          // Escludo colonna
          if (
            key == "Tipologia" ||
            key == "Filtro" ||
            key == "Anno" ||
            key == "Periodo"
          )
            continue;
          res += value[key];
        }
      });

      return (
        res.toLocaleString() +
        (this.filtroTipologia == "Fatturato" ? " € " : "")
      );
    },

    //ritorna la somma dei valori del secondo periodo di confronto
    getSommaC(tipo) {
      let res = 0;
      let arrFilter = this.datiC;
      if (arrFilter == null || arrFilter == []) return;
      arrFilter = arrFilter.filter((x) => x.Filtro == this.filtroTipologia);
      if (tipo) arrFilter = arrFilter.filter((x) => x.Tipologia == tipo);

      arrFilter.forEach((value) => {
        for (var key in value) {
          if (value[key] == -1) continue;
          if (
            key == "Tipologia" ||
            key == "Filtro" ||
            key == "Anno" ||
            key == "Periodo"
          )
            continue;
          res += value[key];
        }
      });

      return (
        res.toLocaleString() +
        (this.filtroTipologia == "Fatturato" ? " € " : "")
      );
    },
    //#endregion

    //#region ORDINAMENTO
    changeSortA(item) {
      // Controllo sort attivo
      if (!item.sortable) return;
      if (this.paginationA.sortBy === item.value) {
        this.paginationA.descending = !this.paginationA.descending;
      } else {
        this.paginationA.sortBy = item.value;
        this.paginationA.descending = false;
      }
    },

    changeSortS(item) {
      // Controllo sort attivo
      if (!item.sortable) return;
      console.log(item);
      if (this.paginationS.sortBy === item.value) {
        this.paginationS.descending = !this.paginationS.descending;
      } else {
        this.paginationS.sortBy = item.value;
        this.paginationS.descending = false;
      }
    },
    //#endregion

    //#region DIALOG AGENTI E CLIENTI RIEPILOGO
    apriDialogCliente(row) {
      if (this.role != "Admin") return;
      this.dialogUser = { Tipo: "Cliente", Codice: row.Cod_cli };
      this.dialogRole = "Cliente";
      this.rigaSelezionata = row;
      this.dialogCliente = true;
    },

    chiudiDialogCliente() {
      this.rigaSelezionata = null;
      this.dialogCliente = false;
    },

    apriDialogAgente(row) {
      if (this.role != "Admin") return;
      this.dialogUser = { Tipo: "Agente", Codice: row.Agente };
      this.dialogRole = "Agente";
      this.rigaSelezionata = row;
      this.dialogAgente = true;
    },

    chiudiDialogAgente() {
      this.dialogAgente = false;
    },
    //#endregion

    //#region FILTRI
    salvaFiltri(filtriSel, tuttiSel) {
      this.filtriSel = filtriSel;
      this.tuttiSel = tuttiSel;
    },

    cambiaFiltro(filtro) {
      if (this.tabs == 0) this.refresh();
      else this.search = filtro;
    },

    getFiltroGrafico() {
      if (this.attesaGrafico == true) return;
      // NON AGGIORNA IL GRAFICO SUL CAMBIO RADIO

      let arrFiltro = this.dati.filter((x) => x.Filtro == this.filtroTipologia);

      let arrSwap = [];

      arrFiltro.forEach((value) => {
        // Ciclo sulle chiavi del json
        for (var key in value) {
          // Escludo colonna
          if (value[key] == -1) continue;
          // Escludo colonna
          if (key == "Tipologia" || key == "Filtro" || key == "Anno") continue;

          if (!!arrSwap.find((f) => f.Serie == key) == false) {
            arrSwap.push({
              Serie: key,
              TotalePorte: value[key],
              Tipologia: value["Tipologia"],
            });
          }
        }
      });
      return arrSwap;
    },

    getFiltroGraficoConfronto() {
      let tot1 = this.getSomma();
      if (tot1 != null && tot1 != undefined) tot1 = tot1.replaceAll(".", "");
      let tot2 = this.getSommaC();
      if (tot2 == undefined || tot2 == null) return [];
      if (tot2 != null && tot2 != undefined) tot2 = tot2.replaceAll(".", "");
      let arr = [
        {
          Serie: "Periodo",
          TotalePorte: this.dati[0].Periodo,
          Tipologia: "",
        },
        {
          Serie: "Periodo 1",
          TotalePorte: tot1.substr(0, tot1.length - 3).replaceAll(",", "."),
          Tipologia: "RIEPILOGO 1",
        },
        {
          Serie: "Periodo 2",
          TotalePorte: tot2.substr(0, tot2.length - 3).replaceAll(",", "."),
          Tipologia: "RIEPILOGO 2",
        },
      ];
      return arr;
    },

    changeSortValue(val) {
      if (val == "Fatturato") {
        this.headersTabella[2].value = "FatturatoPeriodo1";
        this.headersTabella[3].value = "FatturatoPeriodo2";
        this.headersTabella[4].value = "PercIncrementoFatturato";
      } else {
        this.headersTabella[2].value = "QuantitaPeriodo1";
        this.headersTabella[3].value = "QuantitaPeriodo2";
        this.headersTabella[4].value = "PercIncremento";
      }
    },
    //#endregion

    //#region ESPORTAZIONE FILE
    async esportaPdf() {
      this.dialogPDF = false;
      let date = {
        dataDa1: this.dataDa,
        dataA1: this.dataA,
        dataDa2: this.dataDa2,
        dataA2: this.dataA2,
      };
      if (this.tabs == 0) {
        let par = this.returnParams();

        //le date di inizio e fine sono uguali perche ho messo il blocco al pdf quando c'e il confronto date
        //pdf riepilogo confronto date non gestito !!!
        date.dataDa1 = date.dataDa2;
        date.dataA1 = date.dataA2;
        let res = await get_pdf("/serie" + par, date);

        if (res == null) return;
        this.$i2kFunctions.createBlobPdf(res.data);
      } else if (this.tabs == 1 || this.tabs == 2) {
        let par = this.returnParams("PDF");
        /* (this.tabs == 2 ? "/agente" + this.parGlob : this.parGlob) +
          (this.filtroTipologia == "Fatturato" ? "/F" : "/Q"); */

        try {
          let res = await get_pdf(par, date);
          if (res == null) return;
          this.$i2kFunctions.createBlobPdf(res.data);
        } catch (err) {
          console.log(err);
        } finally {
          this.attesa = false;
        }
      }
    },

    async esportaExcel() {
      /**     ----------EXCEL----------     */
      let valBody = [];
      let nomeFile = "foglio excel";

      //dentro valBody ho le righe del file excel
      //[0]titolo1   titolo2   titolo3
      //[1]cella1    cella2    cella3
      //[2]cella1    cella2    cella3
      valBody = this.datiExcel;

      //se sono in confronto date aggiungo le righe dei dati del secondo periodo
      if (
        this.datiExcelConfronto != undefined &&
        this.datiExcelConfronto != null &&
        this.datiExcelConfronto.length > 0
      ) {
        valBody[0][0] = "Periodo 1";
        valBody.push(["Periodo 2"]);
        for (let i = 1; i < this.datiExcelConfronto.length; i++)
          valBody.push(this.datiExcelConfronto[i]);
      }

      let workbook = XLSX.utils.book_new();
      let ws = XLSX.utils.aoa_to_sheet(valBody);

      //larghezza delle colonne
      if (this.tabs == 0) {
        let wscols = [{ wch: 22 }, { wch: 15 }];
        for (let i = 2; i < valBody[0].length; i++) wscols.push({ wch: 12 });
        ws["!cols"] = wscols;
        nomeFile = "statistiche";
      } else if (this.tabs == 1 || this.tabs == 2) {
        let wscols = [{ wch: 40 }];
        //sul riepilogo aumento la dimensione delle celle
        if (this.tabs == 1) {
          wscols.push({ wch: 50 });
          nomeFile = "riepilogo";
        } else if (this.tabs == 2) {
          wscols.push({ wch: 10 });
          nomeFile = "riepilogo_agenti";
        }
        for (let i = 2; i < valBody[0].length; i++) wscols.push({ wch: 20 });
        ws["!cols"] = wscols;
      }

      XLSX.utils.book_append_sheet(workbook, ws, nomeFile.replace("_", " "));

      let wopts = { bookType: "xlsx", bookSST: false, type: "array" };
      //salvo il file (il browser lo scarica in automatico)
      XLSX.writeFile(workbook, nomeFile + ".xlsx", wopts);
    },

    open() {
      if (this.tabs == 0) this.esportaPdf();
      else this.dialogPDF = true;
    },
    //#endregion

    //#region TENDENZE
    aggiornaTendenze() {
      if (this.tabs != 3) this.caricaDatiTendenze = true;
    },

    tendenzeCaricate() {
      this.caricaDatiTendenze = false;
    },

    //#endregion

    //#region PROMOZIONI
    aggiornaPromozioni() {
      if (this.tabs != 4) this.caricaDatiPromozioni = true;
    },

    promozioniCaricate() {
      this.caricaDatiPromozioni = false;
    },

    //#endregion
  },

  async mounted() {
    this.headersTabella = this.returnHeadersTabella();
    this.headersTabellaAgenti = this.returnHeadersTabellaAgenti();
    this.annoSel = this.$i2kFunctions.getYear();
    this.dialogCliente = false;
    this.dialogAgente = false;
    this.rigaSelezionata = null;
    this.dialogUser = null;
    this.dialogRole = "";

    // Carico gli anni
    for (let i = this.startYear; i <= this.annoSel; i++) this.anni.push(i);

    // --- tabella riepilogo
    this.annoSel1 = this.$i2kFunctions.getYear() - 1;
    this.annoSel2 = this.$i2kFunctions.getYear();
    this.dataDa = this.annoSel1 + "-01-01";
    this.dataA = this.annoSel1 + "-12-31";

    //invece che caricare subito i dati visualizzo il badge sul pulsante "Carica dati"
    this.dataChange = true;
  },

  created() {
    this.annoSel = this.$i2kFunctions.getYear();
    this.dialogCliente = false;
    this.dialogAgente = false;
    this.rigaSelezionata = null;
    this.dialogUser = null;
    this.dialogRole = "";
    this.columnSel = this.itemsOrdinamento[0];
    this.CambioData();
  },

  computed: {
    userSwitch: function () {
      return this.$store.getters["user/getUserSwitch"];
    },

    isSmartphone: function () {
      return this.$i2kFunctions.isSmartphone();
    },

    //quando entro come agente devo fare il controllo sulla tab "esposizioni" per nascondere la toolbar dei filtri
    showToolbar() {
      return (
        this.tabs != 3 &&
        this.tabs != 4 &&
        (this.role != "Agente" || this.role != "AgenteCapo")
      );
    },
  },

  watch: {
    userSwitch() {
      if (this.userSwitch != null && this.userSwitch != undefined)
        this.refresh();
    },

    confrontoDate(newVal) {
      if (newVal == true) {
        this.CambioData();
        this.attesaGrafico = true;
      } else {
        this.CambioData();
        //this.caricaDati();
      }
    },

    filtroTipologia(newVal) {
      this.changeSortValue(newVal);
      console.log(this.headersTabella);
    },
  },
};
</script>

<style scoped>
table th {
  border: 1px solid #cbcbcb;
  font-size: 1.1em !important;
  font-weight: bold !important;
}
table td {
  border: 1px solid #cbcbcb;
  font-size: 101% !important;
}
</style>